export default __webpack_public_path__ + "static/media/media-partners2.bcf1bc8e.webp";